import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Sends an old path to its new one, tail and all: the splat, the query string
 * and the hash are carried across, because a bookmark is usually a filtered
 * list (`/licenses?reviewStatus=PENDING`). See `legacyRedirects.tsx` for why
 * this exists and when to delete it.
 */
export function LegacyRedirect({ to }: { to: string }) {
  const params = useParams();
  const { search, hash } = useLocation();
  const rest = params['*'] ? `/${params['*']}` : '';
  return <Navigate to={`${to}${rest}${search}${hash}`} replace />;
}
